<template>
  <b-card header="Opciones de Filtro" class="card-filter">
    <b-btn class="filter-collapse" 
        variant="primary" 
        size="sm"
        @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
      <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
    </b-btn>
    <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
      <b-form>
        <b-form-group
          label="Desde"
          label-for="fechaDesde"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="fechaDesde" 
            v-model="filtro.fechaDesde" 
            type="date">
          </b-form-input>
        </b-form-group>
        <b-form-group
          label="Hasta"
          label-for="fechaHasta"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="fechaHasta" 
            v-model="filtro.fechaHasta" 
            type="date">
          </b-form-input>
        </b-form-group>
      </b-form>

      <div class="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="filtrar">Filtrar</b-button>
        <!--
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="limpiarFiltro">Limpiar</b-button>
        -->
      </div>
    </b-collapse>
  </b-card>  
</template>

<script>
import moment from 'moment';

export default {
  components: {
  },
  props: {
    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
      },
      showOpcionesFiltro: Boolean(false)      
    }
  },
  created() {
      this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
      this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
  },
  computed: {
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
  },
}
</script>

<style>
</style>
